import {
//Редактирование формы
  EDIT_LOGIN,
  EDIT_PASSWORD,
  //Авторизация
  AUTH_START,
  CODE_RESEND_START,
  CODE_RESEND_GOT_TIMEOUT,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  LOGIN_FAILURE,
  SIGN_OUT,
  CLEAR_ERROR,
  //Подтверждение номера телефона
  RECEIVING_AUTH_TOKENS,
  AUTH_TOKENS_RECEIVED_SUCCESSFULLY,
  FAILED_TO_RECEIVE_AUTH_TOKENS,
  AUTH_TOKENS_SERVER_ERROR,
  UPDATE_CODE_VALUES,
  UPDATE_REMAINING_SECONDS,
  //Данные пользователя
  USER_DATA_LOADING_START,
  USER_DATA_LOADING_SUCCESS,
  USER_DATA_LOADING_FAILED,
} from "../actions/auth";

const INITIAL_STATE = {
  login: '',
  password: '',
  isAuthorized: false,
  userLogin: '',
  tokens: null,
  loading: false,
  loginError: false,
  serverError: false,
  tempToken: '',
  phoneNumber: '',
  val1: '',
  val2: '',
  val3: '',
  val4: '',
  seconds: 60, //Время, оставшееся до посторной высылки кода
  codeError: false,
  codeServerError: false,
};

export default function (state = INITIAL_STATE, action) {  
  switch (action.type) {
    //Редактирование формы
    case EDIT_LOGIN:
      return {
        ...state,
        login: action.payload.value,
      };
    case EDIT_PASSWORD:
      return {
        ...state,
        password: action.payload.value,
      };
    //Авторизация
    case AUTH_START:
      return {
        ...state,
        loading: true,
        isAuthorized: false,
        serverError: false,
        loginError: false,
        tempToken: '',
        userLogin: '',
        val1: '',
        val2: '',
        val3: '',
        val4: '',
        codeError: false,
        codeServerError: false,

      };
    //По сути та же акторизация, но не сбрасываем номер телефона 
    case CODE_RESEND_START:
      return {
        ...state,
        loading: true,
        isAuthorized: false,
        serverError: false,
        codeError: false,
        codeServerError: false,
        //seconds: 0, //Время, оставшееся до посторной высылки кода
      };
    case AUTH_SUCCESS:
      //В ответ на запрос мы получили tempToken и phoneNumber (при первом запросе),
      //Далее будет приходить только оставшийся до повторной высылки дода timeout,
      //который будет обновляться через CODE_RESEND_GOT_TIMEOUT
      return {
        ...state,
        loading: false,
        tempToken: action.payload.tempToken,
        phoneNumber: action.payload.phoneNumber,
        seconds: 60,
        val1: '',
        val2: '',
        val3: '',
        val4: '',
      };
    case CODE_RESEND_GOT_TIMEOUT:
      //Проверим, есть ли уже tempToken и phoneNumber, а если нет, достанем их из localStorage
      let tempToken = state.tempToken;
      let phoneNumber = state.phoneNumber;
      if (tempToken.length === 0) tempToken = localStorage.getItem("tempToken");
      if (phoneNumber.length === 0) phoneNumber = localStorage.getItem("phoneNumber");
      return {
        ...state,
        loading: false,
        tempToken: tempToken,
        phoneNumber: phoneNumber,
        seconds: action.payload.timeout,
      };
    //Неправильные логин и пароль
    case LOGIN_FAILURE:
      return {
        ...state,
        tokens: null,
        loading: false,
        loginError: true,
      };
    //Ошибка со стороны сервера при первом шаге авторизации
    case AUTH_FAILURE:
      return {
        ...state,
        tokens: null,
        loading: false,
        serverError: true,
      };
    //Подтверждение номера телефона
    case RECEIVING_AUTH_TOKENS:
      return {
        ...state,
        loading: true,
        codeError: false,
        codeServerError: false,
        //seconds: 60, //Время, оставшееся до посторной высылки кода
      };
    case AUTH_TOKENS_RECEIVED_SUCCESSFULLY:
      return {
        ...state,
        tokens: action.payload,
        loading: false,
        isAuthorized: true,
        tempToken: '',
        phoneNumber: '',
        seconds: 60, //Время, оставшееся до посторной высылки кода
        val1: '',
        val2: '',
        val3: '',
        val4: '',
      };
    //Ввод кода подтверждения
    case UPDATE_CODE_VALUES:
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    //Обратный отсчет времени до нового запроса
    case UPDATE_REMAINING_SECONDS:
      return {
        ...state,
        seconds: action.payload.seconds,
      };
    //Введен неправильный код подтверждения
    //Очищаем форму
    case FAILED_TO_RECEIVE_AUTH_TOKENS:
      return {
        ...state,
        tokens: null,
        loading: false,
        codeError: true,
        isAuthorized: false,
        val1: '',
        val2: '',
        val3: '',
        val4: '',
      };
    //Ошибка сервера при запросе на подтверждение телефона
    case AUTH_TOKENS_SERVER_ERROR:
      return {
        ...state,
        tokens: null,
        loading: false,
        codeServerError: true,
        isAuthorized: false,
      }; 
    case SIGN_OUT:
      return INITIAL_STATE;
    case CLEAR_ERROR:
      return {
        ...state,
        loginError: false,
        serverError: false,
      };
    //Данные пользователя
    case USER_DATA_LOADING_START:
    case USER_DATA_LOADING_FAILED:
      return {
        ...state,
        userLogin: '',
      };
    case USER_DATA_LOADING_SUCCESS:
      return {
        ...state,
        userLogin: action.payload.userLogin.toString(),
      };
    default:
      return state;
  }
}
